import { fromJS } from 'immutable';
import { generateUrls, Selectors, Utils } from '@americanexpress/axp-benefits-utils';
import { getSelectedProduct } from '@americanexpress/product-ducks';

export const FETCH_FILTER_REQUEST = 'modules/axp-benefits-view-all/FETCH_FILTER_REQUEST';
export const FETCH_FILTER_SUCCESS = 'modules/axp-benefits-view-all/FETCH_FILTER_SUCCESS';
export const FETCH_FILTER_ERROR = 'modules/axp-benefits-view-all/FETCH_FILTER_ERROR';
export const UPDATE_BENEFIT_LIST = 'modules/axp-benefits-view-all/UPDATE_BENEFIT_LIST';

const initialState = fromJS({});

export const formatFilter = (filter) => {
  const newFilter = {
    categories: [],
  };
  filter.forEach((catObject) => {
    newFilter.categories.push(catObject.category);
    newFilter[catObject.category] = catObject.ids;
  });
  return newFilter;
};

// eslint-disable-next-line default-param-last -- needed
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_FILTER_REQUEST:
      return state
        .set('data', undefined)
        .set('error', false)
        .set('isFetching', true)
        .set('filteredBenefits', undefined)
        .set('category', undefined);
    case FETCH_FILTER_SUCCESS:
      if (action.data && action.data.data && action.data.data.benefitsContent) {
        return state?.set('error', false)
          .set('data', undefined)
          .set('isFetching', false);
      }
      return state
        .set('data', undefined)
        .set('error', true)
        .set('isFetching', false);
    case FETCH_FILTER_ERROR:
      return state
        .set('data', undefined)
        .set('error', true)
        .set('isFetching', false);
    case UPDATE_BENEFIT_LIST:
      return state
        .set('filteredBenefits', action.payload.newList)
        .set('category', action.payload.category);
    default:
      return state;
  }
}

export const fetchFilter = (cardname, loggedin, windowOrigin, fromParameters) => (
  dispatch, getState
) => {
  let accountToken;
  const state = getState();
  if (loggedin && !fromParameters) {
    accountToken = getSelectedProduct(state);
  }
  const locale = Selectors.getLocale(state);
  const origin = windowOrigin || 'https://global.americanexpress.com';
  const environment = Utils.getSubdomain(origin);
  const environmentLocaleFilename = fromJS(getState()).getIn(['config', 'localeFilename']);
  const { GRAAS_ENDPOINT } = generateUrls(environmentLocaleFilename, windowOrigin);
  const url = GRAAS_ENDPOINT; // mock-benefits-dashboard - do not alter this line
  // const url = 'http://localhost:2020/graphql'; // mock-benefits-dashboard - do not alter this line

  const promise = fetch(url, {
    timeout: 20000,
    method: 'POST',
    ...!fromParameters ? { credentials: 'include' } : {},
    headers: {
      'Content-Type': 'application/json',
      ...accountToken ? { account_token: accountToken } : {},
      cardname,
      // mock: true, // mock-benefits-dashboard - do not alter this line
    },
    body: JSON.stringify({
      variables: {
        environment,
        locale,
        cardname,
        loggedin: fromParameters ? false : loggedin,
      },
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      dispatch({
        data,
        lastFetched: Date.now(),
        type: FETCH_FILTER_SUCCESS,
      });
      return data;
    })
    .catch((error) => {
      dispatch({
        error,
        type: FETCH_FILTER_ERROR,
      });
      return Promise.reject(error);
    });

  dispatch({
    type: FETCH_FILTER_REQUEST,
    promise,
  });

  return promise;
};

export const updateBenefitList = (newList, category) => (dispatch) => dispatch({
  type: UPDATE_BENEFIT_LIST,
  payload: {
    newList,
    category,
  },
});
